import { getCsrfToken, submitSignOut } from '#pplx/frontend/auth/core.js';
import { sanitizedRedirectWindow } from '#pplx/frontend/common/sanitizedRedirectWindow.js';
export function resolveSignOutParams({ redirect = true, callbackUrl = window.location.href, } = {}) {
    return { redirect, callbackUrl };
}
export function redirectAfterSignOut(callbackUrl) {
    sanitizedRedirectWindow(callbackUrl);
    if (callbackUrl.includes('#')) {
        window.location.reload();
    }
}
/**
 * Signs the user out, by removing the session cookie.
 * Automatically adds the CSRF token to the request.
 *
 * [Documentation](https://next-auth.js.org/getting-started/client#signout)
 */
export async function signOut(options = {}) {
    const { redirect, callbackUrl } = resolveSignOutParams(options);
    await submitSignOut({
        csrfToken: await getCsrfToken(),
        callbackUrl,
    });
    if (redirect) {
        redirectAfterSignOut(callbackUrl);
    }
}
//# sourceMappingURL=signOut.js.map